import React, { type ReactNode, useCallback } from 'react';

import Tabs from '@atlaskit/tabs';

type AITabsProps = {
	children: ReactNode;
	onChange?: (index: number) => void;
	selectedTabIndex?: number;
};

export const AITabs = ({
	children,
	selectedTabIndex,
	onChange,
}: AITabsProps): React.JSX.Element => {
	const handleChange = useCallback(
		(index: number) => {
			onChange?.(index);
		},
		[onChange],
	);

	return (
		<Tabs onChange={handleChange} selected={selectedTabIndex ?? 0} id="ai-answer-tabs">
			{children}
		</Tabs>
	);
};
